export const REFINANCE_CONSENT_SIGN_STEP_INITIAL = 0
export const REFINANCE_CONSENT_SIGN_STEP_CHOOSE_PROVIDERS = 1
export const REFINANCE_CONSENT_SIGN_STEP_SMART_ID = 2
export const REFINANCE_CONSENT_SIGN_STEP_MOBILE_ID = 3
export const REFINANCE_CONSENT_SIGN_STEP_ID_CARD = 4
